/**
 * Remembers, per browser, that this person has had Pro. A Pro subscriber who later gets signed out
 * hits the free limit and sees "Upgrade to Pro"; two did this week, and one paid twice
 * (2026-10-21, auto-refunded). The pricing modal uses this to offer "sign in to restore" first.
 * Storage can be missing or throw (private mode, blocked site data), so every access is guarded.
 */
const KEY = 'yt_had_pro';

type MinimalStorage = { getItem(key: string): string | null; setItem(key: string, value: string): void };

export function markHadPro(storage: MinimalStorage | null | undefined): void {
  try {
    storage?.setItem(KEY, '1');
  } catch {
    // Best effort only
  }
}

export function hadProBefore(storage: MinimalStorage | null | undefined): boolean {
  try {
    return storage?.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/** window.localStorage, or null on the server or when merely reading it throws. */
export function browserStorage(): MinimalStorage | null {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}
